import { connect } from 'react-redux';
import { showErrorFlag, showSuccessFlag } from '@helpCenter/state/actions/flags';
import SyncProjectsToggle from './sync-projects-toggle';

export default connect(null, {
    showErrorFlag,
    showSuccessFlag,
})(SyncProjectsToggle);
